module.exports = __webpack_public_path__ + "static/media/responsibility-governance.4b2d07bf.jpg";